import { render, staticRenderFns } from "./ProBadge.vue?vue&type=template&id=6d488ec1&scoped=true&"
import script from "./ProBadge.vue?vue&type=script&lang=js&"
export * from "./ProBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProBadge.vue?vue&type=style&index=0&id=6d488ec1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d488ec1",
  null
  
)

export default component.exports